import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { thunkFetchEventGroups } from '@/redux/actions';
import GroupSelector from './GroupSelector';

/*
Must be wrapped in a Form.Item like:
<Form.Item label="Groups" name="groups">
	<GroupSelector event={event} />
</Form.Item>
*/
const GroupSelectorContainer = props => {
	const { groups, eventID, event, fetchGroups } = props;

	useEffect(() => {
		grabData('GroupSelector.useEffect');
	}, []);

	const grabData = from => fetchGroups(eventID ? eventID : event.id, from);

	return groups && groups.length ? (
		<GroupSelector {...props} groups={groups} />
	) : (
		<div>There are no groups for this event</div>
	);
};

const msp = ({ groups }) => ({
	groups: groups.groups,
});

const mdp = dispatch => ({
	fetchGroups: (eventID, from) => dispatch(thunkFetchEventGroups(eventID, null, from)),
});

export default connect(msp, mdp)(GroupSelectorContainer);
